// extracted by mini-css-extract-plugin
export default {"L1box":"L1_L1box__pTWck","textBox":"L1_textBox__H40oA","L1":"L1_L1__QrUIg"};